export const EXPAND_COL_WIDTH = 52;

export const cellSx = (theme, { muted = false, numeric = false } = {}) => ({
  color: muted ? theme.palette.text.secondary : theme.palette.text.primary,
  fontSize: muted ? "0.8125rem" : undefined,
  fontWeight: muted ? 400 : undefined,
  fontVariantNumeric: numeric ? "tabular-nums" : undefined,
  whiteSpace: "nowrap",
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderColor: theme.palette.divider,
});

export const expandCellSx = (theme) => ({
  width: EXPAND_COL_WIDTH,
  px: 0.5,
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderColor: theme.palette.divider,
  verticalAlign: "middle",
});

export const getTableSx = (theme) => ({
  tableLayout: "fixed",
  width: "100%",
  borderCollapse: "collapse",
  "& .MuiTableCell-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderColor: theme.palette.divider,
  },
});
